export default class {
    constructor (lodash) {
        this.lodash = lodash;
        this.user = undefined; // We will store the currently logged in user here
    }
}



// WEBPACK FOOTER //
// ./src/app/services/state/index.js